import PropTypes from 'prop-types';
import { CivilDate } from 'tc39-proposal-temporal';
import _ from 'underscore';

export const ComparedDateRangePickerPropTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    formatCivilDate: PropTypes.func.isRequired,
    getToday: PropTypes.func.isRequired,
    getDayOfWeek: PropTypes.func.isRequired,
    getFirstDayOfWeek: PropTypes.func.isRequired,
  }).isRequired,
  selectedRange: PropTypes.shape({
    start: PropTypes.instanceOf(CivilDate),
    end: PropTypes.instanceOf(CivilDate),
  }),
  selectedComparedRange: PropTypes.shape({
    start: PropTypes.instanceOf(CivilDate),
    end: PropTypes.instanceOf(CivilDate),
  }),
  specificRanges: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    range: PropTypes.shape({
      start: PropTypes.instanceOf(CivilDate),
      end: PropTypes.instanceOf(CivilDate),
    }),
  })),
  timeZone: PropTypes.string,
  dateFormat: PropTypes.string,
  comparedTypeKey: PropTypes.string,
  rangeId: PropTypes.number,
  rangeIndex: PropTypes.number,
  rangeDays: PropTypes.number,
  onPickDateRanges: PropTypes.func,
  onSwitchCompare: PropTypes.func,
  minDate: PropTypes.instanceOf(CivilDate),
  maxDate: PropTypes.instanceOf(CivilDate),
  disableCompare: PropTypes.bool,
  displayType: PropTypes.bool,
  isMainDatePicker: PropTypes.bool,
  relativeDropdown: PropTypes.bool,
  dateRangeLogger: PropTypes.func,
  isMonthRangePicker: PropTypes.bool,
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  shouldShowQuickLeftRightPicker: PropTypes.bool,
};

export const ComparedDateRangePickerDefaultProps = {
  selectedRange: { start: undefined, end: undefined },
  selectedComparedRange: { start: undefined, end: undefined },
  onPickDateRanges: _.noop,
  onSwitchCompare: _.noop,
  minDate: undefined,
  maxDate: undefined,
  specificRanges: [],
  timeZone: 'US/Pacific',
  dateFormat: 'M/d/yyyy',
  rangeId: undefined,
  rangeIndex: undefined,
  rangeDays: undefined,
  comparedTypeKey: undefined,
  disableCompare: false,
  displayType: false,
  isMainDatePicker: false,
  relativeDropdown: false,
  dateRangeLogger: _.noop,
  isMonthRangePicker: false,
  ariaLabel: undefined,
  ariaLabelledBy: undefined,
  shouldShowQuickLeftRightPicker: false,
};
